import React from 'react'
import './src/styles/global.css'
import JagadPopupWrapper from './src/components/UI/JagadPopupWrapper'

export const wrapPageElement = ({ element, props }) => {
    return (<JagadPopupWrapper {...props}>{element}</JagadPopupWrapper>)
}